























































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";
import {
  getKennungValueDisplay,
  getKennungTitle,
  getKZColumn,
  getKZValue,
} from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";
import { Globals } from "@/Globals";

@Component
export default class EditKostenersatz extends EditPage {
  constructor() {
    super();
    this.query = "Web_NeuerSonstigerBeleg_MA";
    if (this.siteData.editQuery) {
      this.query = this.siteData.editQuery;
      this.mainAic = this.aic; // MA AIC zum Speichern übergeben!
    }
  }
  public disabled: boolean = false;
  public clearable: boolean = false;
  private showDeleteMask: boolean = false;
  private kostenart: string = "";
  private showEssen: boolean = false;
  private showKredit: boolean = false;
  private showBezahlt: boolean = false;
  private showKst: boolean = false;
  private saveVisible: boolean = true;
  private showVollstaendig: boolean = true;
  private showDate: boolean = false;
  public mounted() {
    if (this.siteData.aicReise) {
      this.showVollstaendig = false;
      // darf nur bei den sonstigen Belegen die auf den MA erfasst werden angezeigt werden!
      const Stamm = this.$globalsStt(Globals.Stt, "", "RK_TRAVEL");
      this.jokerStt.push({
        sync: this.siteData.aicReise, // aic Stammsatz
        aic: Stamm.aic, // aic Stammtyp
      });
    }
    if (this.siteData.editQuery) {
      this.query = this.siteData.editQuery;
      this.mainAic = this.aic; // MA AIC zum Speichern übergeben!
    } else {
      this.showDate = true;
    }
    if (this.siteData.newData) {
      this.newData = true;
    }
    if (this.siteData.bewegungsdaten) {
      this.bewegungsdaten = true;
      this.aic = this.siteData.aicBewegung;
    } else {
      if (this.siteData.aicReise) {
        this.bewegungsdaten = false;
        this.aic = this.siteData.aicReise;
      } else {
        this.mainAic = this.$api.user.aic;
        this.mainStt = this.header.aic_Stamm; // MA AIC zum Speichern übergeben!
      }
    }
    this.showLoading = true;
    this.mountedBase();
    if (this.siteData.showDelete) {
      this.showDeleteMask = this.siteData.showDelete;
    }
  }
  protected initialize() {
    const bezahlt = getKennungTitle("RK_NOTPAYED", this.columns);
    if (bezahlt) {
      this.showBezahlt = true;
    }
    const kredit = getKennungTitle("RK_FIRMENKREDITKARTE", this.columns);
    if (kredit) {
      this.showKredit = true;
    }
    const essen = getKennungTitle("RK_ANZ_PERS", this.columns);
    if (essen) {
      this.showEssen = true;
    }
    const kostenstelle = getKennungTitle("COST_CENTRE", this.columns);
    if (kostenstelle) {
      this.showKst = true;
    }
    this.saveVisible = getKZValue(this.data, "save", this.columns);
    if (this.siteData.aicReise) {
      this.saveVisible = true;
    }
    if (this.siteData.aic) {
      this.showDeleteMask = this.saveVisible;
    }
  }
  private save() {
    // achtung wird von den Reisen und vom MA direkt auch aufgerufen!
    const aic = this.siteData.aicReise ?? this.$api.user.aic;
    const me = this;
    if (!this.siteData.reloadData) {
      this.siteData.reloadData = true;
    }
    this.onSave(0, "", "", aic)?.then(() => {
      this.$nextTick(() => me.$emit("save"));
    });
  }
  public bewDelete() {
    if (this.data && this.data.aic_Bew_pool) {
      this.onDelete(this.data.aic_Bew_pool, "");
      if (!this.siteData.reloadData) {
        this.siteData.reloadData = true;
      }
      this.$emit("back");
    }
  }
}
